export default __webpack_public_path__ + "static/oxygen2-1f7a69f31c8ceec40aeda92055f9e2ef.svg";